export const environment = {
    production: false,
    backend: {
        baseUrl: "https://brennero-rmi-dev.elvoon.it"
    },
    google: {
        googleMapsApiKey: "AIzaSyArMOSN7NGeW8-Ki4VTHQXWXh-ihHfjCbY", // #gitleaks:allow
        googleMapsMapId: "9dc4587c16c946f8df265642"
    },
    firebase: {
        apiKey: "AIzaSyBae7UasS1Kx-1XNJO0bb1B2gJcrv3cFs4", // #gitleaks:allow
        authDomain: "brennero-rmi-dev.firebaseapp.com",
        projectId: "brennero-rmi-dev",
        storageBucket: "brennero-rmi-dev.firebasestorage.app",
        messagingSenderId: "593149325346",
        appId: "1:593149325346:web:a2ba5ec389324c9c495a7b"
    }
};
